import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ApplicationService} from '../../services/application.service';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {SelectionChange} from '@angular/cdk/collections';

@Component({
  selector: 'app-tab-task-attachment',
  templateUrl: './tab-task-attachment.component.html',
  styles: [
  ]
})
export class TabTaskAttachmentComponent extends ExcTranslation implements OnInit {
  @Input()
  entityID: any;
  @Input()
  entityType = 'task';
  @Input()
  ConfigAttachmentTable: any;
  @Input()
  SummaryAttachmentTable: any;
  @Input()
  tableDrawerIsLoading: any | undefined;
  @Input()
  Events: ExgEventArgs | any;
  @Input()
  auftragData: any;
  @Input() AttachmentFolderStates: string[] = [];
  @Input() taskList = [] as any[];
  @Output() attachmentFolderStatesChange = new EventEmitter<string[]>();

  localConfig = {
    showAttachmentPreview: (dokID?: string): void => {
      this.appSvc.Document.Preview.OpenModal({objID: this.entityID, attID: dokID}, {Events: this.Events});
    },

    showAttachmentUpdateModal: (node: any): void => {
      if ((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1) {
        if (this.excSecurity.isFeatured('DOCUMENTEDIT')) {
          this.appSvc.Document.Update.OpenModal({dokID: node.dokID}, {Events: this.Events});
        }
      }
    },

    showPDFEditorOverlay: (dokID: string, disabled: boolean): void => {
      if (disabled) {
        this.modal.show('ModalFilePdfEditorComponent', {
          dokID,
          objID: this.entityID,
          Events: this.Events,
          selectedSummary: {
            caseDetails: { data: this.auftragData || {} },
            taskList: { data: this.taskList || [] }
          }
        }).subscribe(() => {});
      }
    },

    openReport: (rowID: any): void => {
      this.appSvc.Report.Open(rowID, {Events: this.Events});
    },

    openQuestionnaire: (row: any): void => {
      const data = { qcnfID: row.dokGroesse, qverID: row.dokID, isTest: false, qverName: row.dokName};
      this.appSvc.QuestionnaireVersion.OpenTab(data);
    },

    editQuestionnaireVersion: (row: any): void => {
      const data = { qcnfID: row.dokGroesse, qverID: row.dokID, isEdit: true, qverName: row.dokName, qverDescription: row.dokBeschreibung};
      this.appSvc.QuestionnaireVersion.OpenModal(data, {Events: this.Events});
    },

    exportQuestionnaireReportExcel: (row: any): void => {
      const data = row.dokID;
      this.appSvc.QuestionnaireVersion.ExportExcelReport(data);
    },

    exportQuestionnaireReportPDF: (row: any): void => {
      const data = row.dokID;
      this.appSvc.QuestionnaireVersion.ExportPDFReport(data);
    },

    deleteAttachment: (node: any): void => {
      if ((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1) {
        this.modal.showSimple(
          this.getRessource('DeleteDocument.Title'),
          this.getRessource('DeleteDocument.Message'),
          true,
          true,
          this.getGlobal('Delete'),
          this.getGlobal('Cancel'),
        ).subscribe((rtVal: boolean) => {
          if (rtVal) {
            this.excRest
              .put(this.excRest.computeUrl('DocumentD', {dokID: node.dokID}), {})
              .subscribe((ret: any) => {
                if (ret) {
                  this.modal
                    .showToast(
                      ret.success ? `${this.getRessource('DeleteDocument.success')}` : this.getRessource('DeleteDocument.fail')
                      , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                      , ret.success ? 'fa-duotone fa-trash-can-check' : 'fa-regular fa-times-circle');

                  this.Events?.Document?.UpdateDialog?.Closed?.emit();
/*
                  this.SummaryAttachmentTable?.LoadSummary();
*/
                }
              });
          }
        });
      }
    },

    addAttachmentToReceipts: (node: any): void => {
      if (this.excSecurity.isFeatured('RECEIPTCREATE') && this.isValidReceipt(node.dokName)) {
        if (this.entityType === 'case') {
          return;
          // this.modal.show('ModalSelectTaskComponent', {entityID: this.entityID}, true)
          //   .subscribe((retValue: any) => {
          //     if (retValue && retValue.length > 0) {
          //       this.excRest
          //         .postBasic(
          //           this.excRest.computeUrl(
          //             'TaskReceiptC_FromDokument'
          //             , {vorgId: retValue[0]})
          //           , {selectedDocs: [{dokID: node.dokID}], rcptStatement: false}
          //           , {})
          //         .subscribe((ret: any) => {
          //           if (ret) {
          //             this.modal
          //               .showToast(ret.success ? `${this.getRessource('AddDocument.success')}` : this.getRessource('AddDocument.fail'), `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`, ret.success ? 'fa-duotone fa-file-invoice-dollar' : 'fa-regular fa-times-circle');
          //             this.Events?.Document?.UpdateDialog?.Closed?.emit();
          //             // this.SummaryAttachmentTable?.LoadSummary();
          //           }
          //         });
          //     }
          //   });
        } else {
          this.modal
            .showSimple(
              this.getRessource('AddDocument.Title'),
              this.getRessource('AddDocument.Message'),
              true,
              true,
              this.getGlobal('Create'),
              this.getGlobal('Cancel')
            ).subscribe((rtVal: boolean) => {
            if (rtVal) {
              this.excRest
                .postBasic(
                  this.excRest.computeUrl(
                    'TaskReceiptC_FromDokument'
                    , {vorgId: this.entityID})
                  , {selectedDocs: [{dokID: node.dokID}], rcptStatement: false}
                  , {})
                .subscribe((ret: any) => {
                  if (ret) {
                    this.modal
                      .showToast(ret.success ? `${this.getRessource('AddDocument.success')}` : this.getRessource('AddDocument.fail'), `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`, ret.success ? 'fa-duotone fa-file-invoice-dollar' : 'fa-regular fa-times-circle');
                    this.Events?.Document?.UpdateDialog?.Closed?.emit();
                    // this.SummaryAttachmentTable?.LoadSummary();
                  }
                });
            }
          });
        }
      }
    },

    addAttachmentToStatements: (node: any): void => {
      if (this.excSecurity.isFeatured('STATEMENTCREATE') && this.isValidReceipt(node.dokName)) {
        if (this.entityType === 'case') {
          this.modal.show('ModalSelectTaskComponent', {entityID: this.entityID}, true)
            .subscribe((retValue: any) => {
              if (retValue && retValue.length > 0) {
                this.excRest
                  .postBasic(
                    this.excRest.computeUrl(
                      'TaskReceiptC_FromDokument'
                      , {vorgId: retValue[0]})
                    , {selectedDocs: [{dokID: node.dokID}], rcptStatement: true}
                    , {})
                  .subscribe((ret: any) => {
                    if (ret) {
                      this.modal
                        .showToast(ret.success ? `${this.getRessource('AddDocumentStatement.success')}` : this.getRessource('AddDocumentStatement.fail'), `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`, ret.success ? 'fa-duotone fa-file-invoice-dollar' : 'fa-regular fa-times-circle');
                      this.Events?.Document?.UpdateDialog?.Closed?.emit();
                      // this.SummaryAttachmentTable?.LoadSummary();
                    }
                  });
              }
            });
        } else {
          this.modal
            .showSimple(
              this.getRessource('AddDocumentStatement.Title'),
              this.getRessource('AddDocumentStatement.Message'),
              true,
              true,
              this.getGlobal('Create'),
              this.getGlobal('Cancel')
            ).subscribe((rtVal: boolean) => {
            if (rtVal) {
              this.excRest
                .postBasic(
                  this.excRest.computeUrl(
                    'TaskReceiptC_FromDokument'
                    , {vorgId: this.entityID})
                  , {selectedDocs: [{dokID: node.dokID}], rcptStatement: true}
                  , {})
                .subscribe((ret: any) => {
                  if (ret) {
                    this.modal
                      .showToast(ret.success ? `${this.getRessource('AddDocumentStatement.success')}` : this.getRessource('AddDocumentStatement.fail'), `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`, ret.success ? 'fa-duotone fa-file-invoice-dollar' : 'fa-regular fa-times-circle');
                    this.Events?.Document?.UpdateDialog?.Closed?.emit();
                    // this.SummaryAttachmentTable?.LoadSummary();
                  }
                });
            }
          });
        }
      }
    },

    refreshLoading: (): void => {
      if (this.tableDrawerIsLoading) {
        this.tableDrawerIsLoading.next(false);
      }
    },

    openAttachmentInBrowser: (document: any): void => {
      if (document.dokMIME.includes('/pdf') || document.dokMIME.includes('image/')) {
        this.appSvc.file.dokument.openInBrowser(document.dokID);
      }
      else {
        this.modal.showToast(this.getRessource('OpenInBrowser.NotOpenInBrowser'), 'md-toast', 'fas fa-exclamation');
      }
    }
  };
  userType: number | any;

  acceptedReceiptFileTypes = ['PDF'];

  constructor(
    public excRest: ExcRestService,
    public appSvc: ApplicationService,
    public excSecurity: ExcSecurityService,
    public enumSvc: EnumerationService,
    private modal: ExgModalService,
    private overlayService: ExgOverlayService,
  ) {
    super();
  }

  /** Map zum schnellen Restore: source -> Ordner-Node */
  private folderBySource = new Map<string, any>();

  ngOnInit(): void {
    this.userType = Number(this.appSvc.UserAttributes()?.type) || 2;


    this.folderBySource.clear();
    for (const f of this.SummaryAttachmentTable.data._data) {
      // Erwartet: f.source ist der interne Ordnername
      if (f && (f.documents?.length)) {
        this.folderBySource.set(f.source + f.dok_enmIdent_DokTyp, f);
      }
    }

    // A) Expand/Collapse verfolgen und aktuelle offenen Ordner an Parent melden
    this.ConfigAttachmentTable.treeControl.expansionModel.changed.subscribe((_: SelectionChange<any>) => {
      const openSources = this.ConfigAttachmentTable.treeControl.expansionModel.selected
        .filter((n: { documents: string | any[]; }) => n && (n.documents?.length))
        .map((n: { source: any, dok_enmIdent_DokTyp: number }) => n.source + n.dok_enmIdent_DokTyp);
      this.attachmentFolderStatesChange.emit(openSources);
    });

    // B) Restore: vom Parent gelieferte 'source'-Werte expandieren
    for (const src of this.AttachmentFolderStates ?? []) {
      const folder = this.folderBySource.get(src);
      if (folder) { this.ConfigAttachmentTable.treeControl.expand(folder); }
    }
  }

  isValidReceipt(fileName: string): boolean {
    return this.acceptedReceiptFileTypes.includes(fileName.slice(fileName.lastIndexOf('.') + 1).toUpperCase());
  }
}
